import { insertAtSelection, TextSelection } from '@utils/insertAtSelection';

// The web mentions lib ships no type declarations. These are the exact
// helpers MentionInput uses internally: `helpers.parseValue` understands the
// stored `{@}[Name](id)` markup, `utils.generate…` maps edits back to it.
const mentionHelpers =
  require('react-native-controlled-mentions-web/dist/utils/helpers') as {
    parseValue: (
      value: string,
      configs: { trigger: string }[]
    ) => { plainText: string; parts: unknown[] };
  };
const mentionUtils =
  require('react-native-controlled-mentions-web/dist/utils/utils') as {
    generateValueFromPartsAndChangedText: (
      parts: unknown[],
      originalText: string,
      changedText: string
    ) => string;
  };

const MENTION_PART_TYPES = [{ trigger: '@' }];

/**
 * Insert `insert` into a MentionInput markup value. The caret/selection the
 * textarea reports indexes the displayed plain text (`@Name`), not the stored
 * markup (`{@}[Name](id)`), so the splice happens on the plain text and is
 * mapped back to markup by the mentions lib — keeping mention tokens intact.
 */
export const insertIntoMentionValue = (
  value: string,
  insert: string,
  selection?: TextSelection | null
): { value: string; caret: number } => {
  const { plainText, parts } = mentionHelpers.parseValue(
    value,
    MENTION_PART_TYPES
  );
  const next = insertAtSelection(plainText, insert, selection);
  return {
    value: mentionUtils.generateValueFromPartsAndChangedText(
      parts,
      plainText,
      next.text
    ),
    caret: next.caret,
  };
};
